/**
 * Using `window.matchMedia` here to check if the screen is smaller than
 * 760px. We handle all screens less than 760px as mobile.
 */
export default function isMobile(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia && window.matchMedia(`(max-width: 760px)`).matches;
}
